import { Box, BoxProps } from "@chakra-ui/react";
import { CurrentActiveUserInterface } from "../../constants/User";
import { useLogoutStore } from "../../store/useLogoutStore";
import useCustomToast from "../../lib/useCustomToast";
import { useNavigate } from "react-router-dom";
import { useBgHover } from "../../themes/colors";

interface Props extends BoxProps {
  user: CurrentActiveUserInterface | null;
  logoutAllUser: boolean;
}

export const ButtonLogout = ({ user, logoutAllUser, ...rest }: Props) => {
  const { isLogoutLoading, logoutUser, logoutAll } = useLogoutStore();
  const navigate = useNavigate();
  const toast = useCustomToast();
  const bgHover = useBgHover();

  return (
    <Box
      as="button"
      px={"20px"}
      py={"16px"}
      color={"secondary"}
      fontSize={"12px"}
      w={"full"}
      textAlign={"left"}
      fontWeight={"600"}
      _hover={{ bg: bgHover }}
      onClick={
        logoutAllUser
          ? () => logoutAll(toast)
          : () => logoutUser(toast, navigate)
      }
      {...rest}
    >
      {logoutAllUser
        ? "Logout semua akun"
        : isLogoutLoading
        ? `Loading...`
        : `Logout Akun 
              ${
                user?.role === "buyer"
                  ? "Pembeli"
                  : user?.role === "supplier"
                  ? "Supplier"
                  : "Reseller"
              }`}
    </Box>
  );
};
